import { Text } from "../../../../../i18n/text.js";
import { MenuContent } from "../../../../../ui/menu/content.js";
import { MenuPopup } from "../../../../../ui/menu/popup.js";
import { MenuRoot } from "../../../../../ui/menu/root.js";
import { MenuTrigger } from "../../../../../ui/menu/trigger.js";
import ForwardRef from "../../../../../icons/dist/react/default/gear.js";
import { Button } from "../../../shared/components/buttons/button.js";
import { ButtonTooltip } from "../../../shared/components/buttons/button-tooltip.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { cn, resolveClassName } from "@videojs/utils/style";
import { settingsText } from "@videojs/core/i18n/text/menu";
//#region src/internal/skins/default-video/components/menus/settings-menu.tsx
/** @jsxImportSource react */
function SettingsMenu({ children, className, ...props }) {
	return /* @__PURE__ */ jsxs(MenuRoot, {
		side: "top",
		align: "center",
		...props,
		children: [/* @__PURE__ */ jsx(ButtonTooltip, {
			label: /* @__PURE__ */ jsx(Text, {
				token: settingsText.key,
				children: settingsText.text
			}),
			side: "top",
			children: /* @__PURE__ */ jsxs(MenuTrigger, {
				render: /* @__PURE__ */ jsx(Button, {}),
				className: (state) => cn("media-settings-menu-trigger", resolveClassName(className, state)),
				children: [/* @__PURE__ */ jsx(ForwardRef, { className: cn("media-button-icon", "media-settings-menu-trigger-icon") }), /* @__PURE__ */ jsx(Text, {
					className: "media-settings-menu-trigger-label",
					token: settingsText.key,
					children: settingsText.text
				})]
			})
		}), /* @__PURE__ */ jsx(MenuPopup, {
			keepMounted: true,
			className: cn("media-popup", "media-popup-surface", "media-menu-popup", "media-menu-resizable-popup"),
			children: /* @__PURE__ */ jsx(MenuContent, {
				className: "media-menu-content",
				children
			})
		})]
	});
}
//#endregion
export { SettingsMenu };

//# sourceMappingURL=settings-menu.js.map